import {Component, Input, OnInit} from '@angular/core';
import {UnitDemandModel} from '../../dashboard/monitoring/unit-demand.model';
import { Observable } from 'rxjs';
import {ViewInfoBlock} from '../../shared/card-view/view-info-block/view-info-block.models';
import { map } from 'rxjs/operators';
import {
  PrepaidSharingPricePlanTabs
} from '../../prepaid-sharing-price-plan/prepaid-sharing-price-plan-list/view/prepaid-sharing-price-plan-tabs';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-unit-demand',
  templateUrl: './unit-demand.component.html',
  styleUrls: ['./unit-demand.component.scss']
})
export class UnitDemandComponent implements OnInit {

  @Input() unitDemands: Observable<UnitDemandModel[]>;
  infoBlocks: Observable<ViewInfoBlock[]>;

  constructor(
    private translateService: TranslateService
  ) {
  }

  ngOnInit() {
    this.infoBlocks = this.unitDemands.pipe(
      map(
        unitDemands => unitDemands.map(
          ud => ({
            title: ud.businessLogicCustomName,
            items: [
              {
                title: 'Location',
                description: this.translateService.instant(ud.geofence_id ? 'Geofence' : 'Region'),
              },
              ud.geofence_id ?
                {
                  title: 'Geofence',
                  description: ud.geofence_id.toString() + ' ' + ud.geofenceName
                } : {
                  title: 'Region',
                  description: ud.region_id.toString() + ' ' + ud.regionName
                },
              {
                title: 'Demand',
                description: ud.demand_percent.toString() + '%',
              },
              {
                title: 'Available units',
                description: ud.unit_count.toString()
              },
              {
                title: 'Orders',
                description: ud.order_count.toString()
              },
              {
                title: 'Time',
                description: ud.calculated_at
              },
            ]
          })
        )
      )
    );
  }

  protected readonly PrepaidSharingPricePlanTabs = PrepaidSharingPricePlanTabs;
}
